

import { mapActions, mapState } from 'vuex'

export default {
  name: 'AnchorCategory',
  props: {
    data: {},
    selectedCategory: String,
  },
  computed: {
    ...mapState([ 'menu', 'channel' ]),
    catId() {
      if (this.data && this.data.name) {
        return this.$utils.kebab(this.data.name)
      }

      return null
    },
    anchorId() {
      return `anchor-${this.catId}`
    },
    link() {
      return `#${this.catId}`
    },
    category() {
      return this.$utils.capitalize(this.data.name)
    },
  },
  methods: {
    ...mapActions([ 'trackEvent' ]),
    scroll() {
      this.trackEvent({
        name: 'view_item_list',
        data: this.data,
        windowObject: window,
        affiliation: this.channel ? this.channel : 'default'
      })
      const $element = document.getElementById(this.catId)
      $element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }
}
